import { createRouter, createWebHashHistory } from 'vue-router'
import { parseRoutes, applyDefaultValues, applyMiddlewares } from '../router/helpers'
import RoutesEnum from 'enums/routes.enum'
import '~/env'

const routes = parseRoutes(
    require
        .context('./routes/', true, /^\.\/.*\.js$/)
        .keys()
        .reduce((routes, file) => {
            const route = file.replace('./', '').replace('.js', '')
            return routes.concat(require(`./routes/${route}`).default)
        }, [])
        .concat([
            {
                path: '/:catchAll(.*)',
                name: RoutesEnum.ERROR.NOT_FOUND,
                view: 'errors/NotFound',
                meta: {
                    layout: 'simple',
                },
            },
        ]),
)

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes,
})

router.beforeEach((to, from, next) => {
    to = applyDefaultValues(to)
    to = applyMiddlewares(to)

    if (from.name) {
        router.previousRoute = { ...from }
    }
    if (to.fullPath.endsWith('#/')) {
        to.fullPath = to.fullPath.slice(0, -2)
    }

    next()
})

export default router
